import './SuiteDropdown.css'

export default function SuiteDropdown({user, isMobile}) {
    

  return (
    <div className='dropdown SuiteDropDown navItem'>
        <div className='suiteDropDownToggle' id="suiteDropDownToggle" data-title='Redirect' data-bs-toggle="dropdown" aria-expanded="false">
            <div className='shell'>
                D
            </div>
            { !isMobile &&
            <div className='mainText'>
                Docket
            </div>
            }
            <div className='arrow'>
                <svg width="10" height="15" viewBox="0 0 10 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 10L5 14L9 10" stroke="#192434" strokeOpacity="0.6" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M1 5L5 1L9 5" stroke="#192434" strokeOpacity="0.6" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </div>
        </div>
        <div className='dropdown-menu suiteDropDown' aria-labelledby="suiteDropDownToggle">
            { ([ 'admin', 'manager' ].includes(user.userType) ) &&
            <div className='dropdownItem'>
                <a href="https://app.riahipatents.com" target='_blank' rel="noreferrer">
                    <div className='shell'>CP</div>
                    { !isMobile &&
                    <div className='mainText'>Client Portal</div>
                    }
                </a>
            </div>
            }
            { ([ 'admin', 'manager', 'analyst' ].includes(user.userType) ) &&
            <div className='dropdownItem'>
                <a href="https://patanalysis.riahipatents.com/" target='_blank' rel="noreferrer">
                    <div className='shell'>P</div>
                    { !isMobile &&
                    <div className='mainText'>PatAnalysis</div>
                    }
                </a>
            </div>
            }
        </div>
    </div>
  )
}
